/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { EFormNavigationDirections } from '../../../constants';
export var defaultStepControlsContextValue = {
  currentStep: {
    code: '',
    question: {
      code: '',
      fields: [],
      title: ''
    },
    nextStep: []
  },
  maxStepsCount: 0,
  currentStepCount: 0,
  setNextStep: function setNextStep() {
    return Promise.resolve();
  },
  setPrevStep: function setPrevStep() {
    return Promise.resolve();
  },
  isFirstStep: false,
  resetError: function resetError() {
    return null;
  },
  stepError: '',
  lastNavDirection: EFormNavigationDirections.Forward
};
export var stepControlsContextObj = /*#__PURE__*/React.createContext(defaultStepControlsContextValue);
export var StepControlsContextProvider = stepControlsContextObj.Provider;